let swiperInstance;

function initSwiper() {
  if (swiperInstance) swiperInstance.destroy(true, true);

  swiperInstance = new Swiper(".swiper", {
    loop: true,
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    on: {
      slideChange: function () {
        const visibleSlides = document.querySelectorAll(
          ".swiper-slide:not(.hidden)"
        ).length;
        const currentIndex = this.realIndex % visibleSlides;
        document.querySelector(".current-slide").innerText = currentIndex + 1;
      },
      init: function () {
        const visibleSlides = document.querySelectorAll(
          ".swiper-slide:not(.hidden)"
        ).length;
        document.querySelector(".total-slides").innerText = visibleSlides;
        document.querySelector(".current-slide").innerText = 1;
      },
    },
  });
}

function filterSlidesByColor(color) {
  const slideWrapper = document.querySelector(".swiper-wrapper");
  const colorSwatches = document.querySelectorAll('.flash-forward_colors-button');
  const colors = Array.from(colorSwatches).map((swatch) => {
    const colorValue = swatch.dataset.color.toLowerCase();
    return colorValue;
  });

  const slides = document.querySelectorAll(".swiper-slide--inactive");
  slides.forEach((slide) => {
    slide.classList.remove("hidden");
    slide.classList.add("swiper-slide--inactive");
  });
  slideWrapper.innerHTML = "";

  slides.forEach((slide, i) => {
    const slideColor = slide.dataset.color.toLowerCase();
    let hasAnyColor = colors.find((color) => slideColor.includes(color));

    if (!slideColor || !hasAnyColor || slideColor.includes(color)) {
      let slideClone = slide.cloneNode(true);
      let newSlide = slideWrapper.appendChild(slideClone);

      newSlide.classList.remove("hidden");
      newSlide.classList.remove("swiper-slide--inactive");
      newSlide.classList.add("swiper-slide");
    } 
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initSwiper();

  document
    .querySelectorAll(
      'input[name="options[Color]"], select[name="options[Color]"]'
    )
    .forEach((input) => {
      input.addEventListener("change", function () {
        const selectedColor = this.value.toLowerCase();
        filterSlidesByColor(selectedColor);
        initSwiper(); // Re-initialize swiper after filtering
      });
    });


  document.addEventListener("colorChange", function (e) {
    const newColor = e.detail.color;
    filterSlidesByColor(newColor);
    initSwiper(); // Re-initialize swiper after filtering
  });

  let selectedColor = document.querySelector('.flash-forward_colors-button.selected');
  if (selectedColor) {
    const color = selectedColor.dataset.color.toLowerCase();
    filterSlidesByColor(color);
    initSwiper(); // Re-initialize swiper after filtering
  }
  
});
